"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerNetworkBuildResultSerializedSchema = void 0;
const zod_1 = require("zod");
const AnalysisType_1 = require("../../AnalysisRequirements/AnalysisType");
const NetworkBuilderMessageResult_1 = require("./NetworkBuilderMessageResult");
const SerializedElectricalSchematicViewCollection_1 = require("../SerializedElectricalSchematicViewCollection");
exports.PowerNetworkBuildResultSerializedSchema = zod_1.default.object({
    type: zod_1.default.literal(AnalysisType_1.AnalysisType.PowerNetworkBuild),
    result: zod_1.default.object({
        processResult: NetworkBuilderMessageResult_1.NetworkBuilderMessageResultSchema,
        views: SerializedElectricalSchematicViewCollection_1.SerializedElectricalSchematicViewCollectionSchema,
    }),
});
//# sourceMappingURL=PowerNetworkBuildResultSerialized.js.map